import { useState } from 'react';
import { applyTheme, currentTheme, storeTheme, type Theme } from '../lib/theme';
import { Icon } from './Icon';

/**
 * Switches between the dark and light themes.
 *
 * Initial state is read from <html> rather than from storage, so every instance agrees with
 * what is actually on screen — including the theme the boot script applied before React ran.
 */
export function ThemeToggle({ className = 'icon-btn' }: { className?: string }) {
  const [theme, setTheme] = useState<Theme>(() =>
    typeof document === 'undefined' ? 'dark' : currentTheme(),
  );

  const next: Theme = theme === 'dark' ? 'light' : 'dark';

  return (
    <button
      type="button"
      className={className}
      onClick={() => {
        applyTheme(next);
        storeTheme(next);
        setTheme(next);
      }}
      aria-label={`Switch to ${next} theme`}
      title={`Switch to ${next} theme`}
    >
      <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
    </button>
  );
}
